<div class="dropdown-status h-[30px]">
	<div
		class="selected"
		[ngStyle]="{ background: node.roles ? node.color : false }"
		class="rounded-[10px] px-3 py-1 cursor-pointer"
		(click)="dropdown()"
	>
		<span class="relative">
			{{ node.name }}
		</span>
		<!-- class="absolute top-[25px] left-[-12px]" -->
	</div>
	<div class="dropdown" *ngIf="active">
		<div class="dropdown__options">
			<div
				class="dropdown__options__item"
				(click)="elementSelectedItem(elem)"
				[ngStyle]="{ background: elem.color }"
				*ngFor="let elem of elements"
			>
				<span>
					{{ elem.name | titlecase }}
				</span>
			</div>
		</div>
	</div>
</div>
